import "../styles/global";
import "../styles/variables";
